module.exports = __webpack_public_path__ + "img/success.256510b4.png";